import { Component, Input, OnInit, ViewChild, EventEmitter, OnDestroy, AfterViewInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { NgForm } from '@angular/forms';
import { IonicSelectableComponent } from 'ionic-selectable';
import { Subscription } from 'rxjs';
import { CsiteSupplier, ProformasFilter, ProformasStates } from '@arpada/arp-lib-common-qupro';
import { PortalProveedorService } from '../../../../services/api.services';
import { ProformasFilterComponentsValues } from '../../../../models/api.models';
import { ActionsSharedData } from '../actions.shared.data';
import { IssuePopulateService } from '../../../../services/populators/issue-populate.service';

@Component({
  selector: 'app-filter-proforma',
  templateUrl: './filter-proforma.component.html',
  styleUrls: ['./filter-proforma.component.scss'],
})

export class FilterProformaComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() sharedData: ActionsSharedData;
  @Input() operarios: any[];
  @Input() filter: ProformasFilter;
  @Input() filterChange = new EventEmitter();
  @Input() isModal: boolean;

  @ViewChild('filterForm', { static : true }) filterForm: NgForm;
  @ViewChild('csitesSelectable', { static: true }) csitesSelectable: IonicSelectableComponent;

  detectChanges = false;
  componentsValues: ProformasFilterComponentsValues = null;
  disableOperatorFilter = true;
  private detectChangesSubscription: Subscription = null;
  private loginRedirectSubscription: Subscription;
  private modalId: string = null;

  constructor(
    private modalController: ModalController, 
    private portalProveedorService: PortalProveedorService,
    private issuePopulateService: IssuePopulateService
    ) { }

  ngOnInit() {
    this.modalController.getTop().then((top: HTMLIonModalElement) => {
      this.modalId = top.id; // Get modal ID for close it
    });

    const operatorGlobalSelected = this.portalProveedorService.getOperatorSel();
    if (!operatorGlobalSelected || operatorGlobalSelected === undefined || operatorGlobalSelected === -2) {
      this.disableOperatorFilter = false;
    }
    this.componentsValues = {
      acceptedIsChecked: this.filter && this.filter.containsStateKey(ProformasStates.ACCEPTED),
      invoicedIsChecked: this.filter && this.filter.containsStateKey(ProformasStates.INVOICED),
      pendingIsChecked: this.filter && this.filter.containsStateKey(ProformasStates.PENDING),
      rejectedIsChecked: this.filter && this.filter.containsStateKey(ProformasStates.REJECTED),
      dateFrom: this.filter ? this.issuePopulateService.getStringOfTimestamp(this.filter.date_from) : null,
      dateTo: this.filter ? this.issuePopulateService.getStringOfTimestamp(this.filter.date_to) : null,
      csiteId: this.filter ? this.filter.csite_id : null,
      operatorId: this.initOperatorNum(this.filter.operator_num),
      id: this.filter ? this.filter.id : null,
    };
  }

  private initOperatorNum(num: number): number {
    let operatorNum: number;
    if (num) {
      operatorNum = num;
    } else {
      operatorNum = -2; // caso de TODOS
    }
    return operatorNum;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.detectChanges = true;
      this.detectChangesSubscription = this.filterForm.valueChanges.subscribe(this.onChangeComponent);
    });
  }

  onChangeComponent = () => {
    if (this.detectChanges) {
      setTimeout(() => {
        this.updateFiltro();
      }, 50); // Time to apply filters, after change this.filter
    }
  }

  ngOnDestroy() {
    if (this.detectChangesSubscription) {
      this.detectChangesSubscription.unsubscribe();
    }
    this.detectChanges = false;
    if (this.loginRedirectSubscription) {
      this.loginRedirectSubscription.unsubscribe();
    }
  }

  isTotalCountDefined() {
    return this.sharedData && this.sharedData.totalCount
      && this.sharedData.totalCount !== '' && parseInt(this.sharedData.totalCount, 10) >= 0;
  }

  clearDateFilter(dateFilterPropertyKey: string) {
    if (this.componentsValues && this.componentsValues[dateFilterPropertyKey]) {
      this.componentsValues[dateFilterPropertyKey] = null;
      this.updateDates();
    }
  }

  onSelectCsitesId(eventSelectable: {component: IonicSelectableComponent, isSelected: boolean, item: CsiteSupplier}) {
    if (!this.componentsValues.csiteId) {
      this.componentsValues.csiteId = null;
    }
    const index: number = this.componentsValues.csiteId = eventSelectable.item.id;
    if (eventSelectable.isSelected) {
      if (index > 0) {
        this.componentsValues.csiteId = eventSelectable.item.id;
      }
    } else {
      // creo que no hace falta
      // console.log('this.componentsValues.csiteId: ', this.componentsValues.csiteId);
    }
    setTimeout(() => {
      this.updateFiltro();
    }, 50); // Time to apply filters, after change this.filter
  }

  clearCsitesSelectedItems() {
    this.componentsValues.csiteId = null;
    this.updateFiltro();
  }

  updateFiltro() {
    if ( !this.componentsValues ) { return; }
    this.updateCsites();
    this.updateId();
    this.updateStates();
    this.updateDates();
    this.updateOperario();
    this.filterChange.emit(this.filter);
  }

  public dismiss() {
    this.detectChanges = false;
    this.modalController.dismiss({
      dismissed: true
    }, null, this.modalId);
  }

  private updateId() {
    this.filter.id = this.componentsValues.id;
  }

  private updateCsites() {
    this.filter.csite_id = this.componentsValues.csiteId;
  }

  private updateStates() {
    const states: string[] = [];
    if (this.componentsValues.acceptedIsChecked) {
      states.push(ProformasStates.ACCEPTED);
    }
    if (this.componentsValues.invoicedIsChecked) {
      states.push(ProformasStates.INVOICED);
    }
    if (this.componentsValues.pendingIsChecked) {
      states.push(ProformasStates.PENDING);
    }
    if (this.componentsValues.rejectedIsChecked) {
      states.push(ProformasStates.REJECTED);
    }
    this.filter.setStateKeys(states);
  }

  private updateDates() {
    if (this.componentsValues.dateFrom) {
      const createDateFrom: Date = new Date(this.componentsValues.dateFrom);
      createDateFrom.setHours(0, 0, 0, 0);
      this.filter.date_from = createDateFrom.getTime();
    } else {
      this.filter.date_from = null;
    }
    if (this.componentsValues.dateTo) {
      const createDateTo: Date = new Date(this.componentsValues.dateTo);
      createDateTo.setHours(23, 59, 59, 999);
      this.filter.date_to = createDateTo.getTime();
    } else {
      this.filter.date_to = null;
    }
  }

  private updateOperario() {}

  // private getStringOfTimestamp(timestamp: number): string {
  //   let toReturn: string = null;
  //   if (timestamp) {
  //     toReturn = new Date(timestamp).toISOString();
  //     // formatDate( timestamp, 'YYYY-MM-DDThh:mm:ss.sTZD', 'es', '+0100');
  //   }
  //   return toReturn;
  // }

}
